import { createContext } from 'react';

import RootStore from './rootStore';
import UiStore from './uiStore';
import RatingStore from './ratingStore';
import GeoStore from './geoStore';
import FeatureStore from './featureStore';
import BannerStore from './bannerStore';
import logger from '../logger';

const uiStore = new UiStore();
const ratingStore = new RatingStore();
const geoStore = new GeoStore();
const featureStore = new FeatureStore();
const bannerStore = new BannerStore(featureStore);

// Инициализируем bannerStore после загрузки featureStore
const initializeStores = async () => {
  await featureStore.initializeEnablersAndSiteFeatures();
  bannerStore.initializeBanners();
};

initializeStores().catch((error) => {
  logger.error(error, { sentryMessage: 'Error while initializing featureStore and bannerStore' });
});

const rootStore = new RootStore(
  uiStore,
  ratingStore,
  geoStore,
  featureStore,
);

const stores = {
  rootStore,
  uiStore,
  ratingStore,
  geoStore,
  featureStore,
  bannerStore,
};

export default stores;

if (!process.env.IS_PRODUCTION) {
  window.__STORES__ = stores;
}

export const storesContext = createContext(stores);
